import { useToken } from "./tokenContext";
import axios from "axios";

const useApi = () => {
  const { token } = useToken();
  const apiUrl = process.env.REACT_APP_API_URL;

  // Função auxiliar para criar instâncias de API com a porta correta
  const createApiInstance = () => {
    return axios.create({
      baseURL: `${apiUrl}`,
    });
  };

  const fetchData = async (url) => {
    const api = createApiInstance();
    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  };

  const deleteData = async (url) => {
    const api = createApiInstance();
    const response = await api.delete(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  };

  const updateData = async (url, data) => {
    const api = createApiInstance();
    const response = await api.put(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  };

  const postData = async (url, data) => {
    const api = createApiInstance();
    const response = await api.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  };

  const userLogin = async (url, data) => {
    const api = createApiInstance();
    const response = await api.post(url, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  };

  const postCSV = async (url, data) => {
    const api = createApiInstance();
    const response = await api.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    });
    return response;
  };

  return { fetchData, deleteData, updateData, postData, postCSV, userLogin };
};

export default useApi;
